import React, { useState, useEffect } from 'react'
import { PasswordEyeClose, PasswordEyeOpen, InfoIcon } from '../common/icons'
import './resetPassword.css'
import cogniLogo from '../../images/cogni_logo.png'
import leftPanelImage from '../../images/workspace_1.png'
import Axios from 'axios'
import { ErrorPage } from '../error/SignupErrorPage'
import { Loader } from '../common/loader/loader'

const PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?=.{8,})/

const initialData = {
    newPwd: '',
    confirmPwd: '',
}

const errorInitialState = {
    newPwdErr: false,
    confirmPwdErr: false,
    msg: '',
}

export const ResetPassword = props => {
    const [state, setPassword] = useState(initialData)
    const [error, setError] = useState(errorInitialState)
    const [eyeState, setEyeState] = useState({
        newPwdEye: false,
        confirmPwdEye: false,
    })
    const [showPasswordResetSuccess, setShowPasswordResetSuccess] = useState(
        false
    )
    const [loading, setLoading] = React.useState(false)

    const changePassword = () => {
        const req = {
            email: props.match.params.email,
            new_password: state.newPwd,
            token: props.match.params.verificationId,
        }
        setLoading(true)
        Axios.put(process.env.REACT_APP_PASSWORD_RESET_URL, req)
            .then(response => {
                setLoading(false)
                setShowPasswordResetSuccess(true)
            })
            .catch(err => {
                console.log(err.response.data.invalid_verification)
                if (
                    err.response.status >= 400 &&
                    err.response.status < 500 &&
                    err.response.data.invalid_verification
                ) {
                    setError({
                        msg: 'Link expired ',
                        confirmPwdErr: false,
                        newPwdErr: true,
                    })
                } else {
                    setError({
                        msg: 'Something Went Wrong',
                        confirmPwdErr: false,
                        newPwdErr: true,
                    })
                }
                setLoading(false)
            })
    }

    const getDisableValue = () => {
        const disable =
            state.newPwd.length === 0 ||
            state.confirmPwd.length === 0 ||
            error.confirmPwdErr ||
            error.newPwdErr
        return disable
    }

    useEffect(() => {
        if (state.newPwd.length > 0 && !PasswordRegex.test(state.newPwd)) {
            setError({
                ...error,
                newPwdErr: !PasswordRegex.test(state.newPwd),
                msg: 'Enter valid password.',
                confirmPwdErr: false,
            })
        } else if (
            state.confirmPwd.length > 0 &&
            !PasswordRegex.test(state.confirmPwd)
        ) {
            setError({
                confirmPwdErr: !PasswordRegex.test(state.confirmPwd),
                msg: 'Enter valid password.',
                newPwdErr: false,
            })
        } else if (
            state.newPwd.length > 0 &&
            state.confirmPwd.length > 0 &&
            state.newPwd !== state.confirmPwd
        ) {
            setError({
                confirmPwdErr: true,
                msg: 'Password does not match',
                newPwdErr: false,
            })
        } else {
            setError(errorInitialState)
        }
    }, [state])

    return showPasswordResetSuccess ? (
        <ErrorPage
            {...props}
            fromPasswordReset={true}
            showPasswordResetSuccess={showPasswordResetSuccess}
        />
    ) : (
        <section className="bg_img_login password_reset">
            <div className="login_bg_height">
                <div className="login_bg_width">
                    <div className="row">
                        <div className="col-md-6 col-lg-6 login_bg_width_left">
                            <img
                                className="centerImage"
                                src={cogniLogo}
                                alt="Assistant"
                                title="Assistant"
                            />
                            <h2>
                                Welcome back to <span>Workativ Assistant</span>
                            </h2>
                            <p>
                                Please choose a new password to finish signing
                                in.
                            </p>
                            <div className="left_bottom_img">
                                <img
                                    src={leftPanelImage}
                                    align="middle"
                                    alt="Password"
                                    title="Password"
                                />
                            </div>
                        </div>
                        {loading ? (
                            <div className="col-md-6 col-lg-6 login_bg_width_left_right">
                                <Loader.PopupLoader show={true} />
                            </div>
                        ) : (
                            <div className="col-md-6 col-lg-6 login_bg_width_left_right">
                                <h3>Reset your password</h3>
                                <div className="login_bg_width_left_right_form">
                                    <div
                                        className={
                                            error.newPwdErr
                                                ? 'form-group_error form-group reset_password'
                                                : 'form-group reset_password'
                                        }
                                    >
                                        <label for="pwd">New Password</label>
                                        {error.newPwdErr && (
                                            <span className="password-error">
                                                {error.msg}
                                            </span>
                                        )}
                                        <span
                                            tooltip="Include 1 special character, number, capital letter and small letter with minimum 8 characters"
                                            flow="right"
                                            className="first-span"
                                        >
                                            <InfoIcon />
                                        </span>
                                        <input
                                            type={
                                                eyeState.newPwdEye
                                                    ? 'text'
                                                    : 'password'
                                            }
                                            className="form-control"
                                            id="pwd"
                                            placeholder="Enter your Password..."
                                            onChange={e =>
                                                setPassword({
                                                    ...state,
                                                    newPwd: e.target.value,
                                                })
                                            }
                                        />
                                        <span
                                            onClick={() =>
                                                setEyeState({
                                                    ...eyeState,
                                                    newPwdEye: !eyeState.newPwdEye,
                                                })
                                            }
                                        >
                                            {!eyeState.newPwdEye ? (
                                                <PasswordEyeClose />
                                            ) : (
                                                <PasswordEyeOpen />
                                            )}
                                        </span>
                                    </div>
                                    <div
                                        className={
                                            error.confirmPwdErr
                                                ? 'form-group_error form-group reset_password'
                                                : 'form-group reset_password'
                                        }
                                    >
                                        <label for="pwd">
                                            Confirm New Password
                                        </label>
                                        {error.confirmPwdErr && (
                                            <span className="password-error">
                                                {error.msg}
                                            </span>
                                        )}
                                        {/* <span tooltip="Include 1 special character, number, capital letter and small letter with minimum 8 characters" flow="right" className="first-span">
                                        <InfoIcon />
                                    </span> */}
                                        <input
                                            type={
                                                eyeState.confirmPwdEye
                                                    ? 'text'
                                                    : 'password'
                                            }
                                            className="form-control"
                                            id="pwd"
                                            placeholder="Enter your password..."
                                            onChange={e =>
                                                setPassword({
                                                    ...state,
                                                    confirmPwd: e.target.value,
                                                })
                                            }
                                        />
                                        <span
                                            onClick={() =>
                                                setEyeState({
                                                    ...eyeState,
                                                    confirmPwdEye: !eyeState.confirmPwdEye,
                                                })
                                            }
                                        >
                                            {!eyeState.confirmPwdEye ? (
                                                <PasswordEyeClose />
                                            ) : (
                                                <PasswordEyeOpen />
                                            )}
                                        </span>
                                    </div>
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={getDisableValue()}
                                        style={{ marginTop: 15 }}
                                        onClick={() => changePassword()}
                                    >
                                        Change Password
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    )
}
